import { ProgramsType } from '@shared/generated';

export const isProgramsType = (str: unknown): str is ProgramsType => {
  return Object.values(ProgramsType).includes(str as ProgramsType);
};
